"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestType = void 0;
var RequestType;
(function (RequestType) {
    RequestType["DRAWDOWN"] = "drawdown";
    RequestType["DELAY"] = "delay";
    RequestType["MILESTONE_COMPLETED"] = "milestone_completed";
    RequestType["DISPUTE"] = "dispute";
})(RequestType || (exports.RequestType = RequestType = {}));
